var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStocking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.007 251.5L57.008 277.5C-1.74 316.75 -17.74 396.25 21.509 455C46.258 492 86.757 512 128.131 512C152.506 512 177.255 505 199.005 490.5L280.753 436C325.251 406.25 351.876 356.5 351.876 302.875V128H96.007V251.5ZM352.001 0H96.007C78.408 0 64.008 14.4 64.008 32V64C64.008 81.6 78.408 96 96.007 96H352.001C369.6 96 384 81.6 384 64V32C384 14.4 369.6 0 352.001 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStocking);
export default __webpack_public_path__ + "static/media/stocking.6ad59db6500cc8629f4c2e981a0a18ea.svg";
export { ForwardRef as ReactComponent };